import React from "react";
import BlockUi from '@availity/block-ui';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from 'react-loader-spinner';
// import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import { DropDownList,MultiSelect } from '@progress/kendo-react-dropdowns';
import { Grid, GridColumn, GridToolbar } from '@progress/kendo-react-grid';
import {process} from '@progress/kendo-data-query';
import RFQDetailComponent from './RFQDetailComponent';
import './RFQ.scss';
import {NumericFormat} from "react-number-format";

class RFQQuotationGrid extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: -1,
            quotegridData : [],
            selectedID : null,
            
        }
    }

    componentDidMount()
    {
        this.setState({quotegridData : this.props.quoteData});
    }

    render()
    {
        const grid = (

            <Grid
                ScrollMode="scrollable"
                pageable = {true}
                sortable
                
               
                 data={this.state.quotegridData.map(
                     
                    (item) => ({ ...item, selected: item.quoteNum === this.state.selectedID }))
                }
           
                ref={(grid) => { this._grid = grid; }}
                onRowClick={(e) => {
                    ;
                    this.setState({ selectedID: e.dataItem.quoteNum });
                   this.props.getSelectedQuotation(e.dataItem);
               }}
               selectedField="selected"
           
    
            >
                 <GridColumn field="quoteNum" title="Quotation Number"  width="150px" />    
                <GridColumn field="awardStatDesc" title="Status"    width="180px"   />                     
                <GridColumn field="quoteStatDesc" title="Response Code"  width="200px" />
                <GridColumn field="submittedPrice" title="Price Proposal"   width="150px" 
                    cell={(props) => (
                        <td>
                            <NumericFormat
                                value={Number(props.dataItem.submittedPrice)}
                                displayType={"text"}
                                thousandSeparator={true}
                                decimalSeparator={
                                    props.dataItem.submittedCurrency !== "JPY" ? "." : ""
                                }
                                decimalScale={props.dataItem.submittedCurrency !== "JPY" ? "2" : "0"}
                                fixedDecimalScale={
                                props.dataItem.submittedCurrency !== "JPY" ? "true" : "false"
                                }
                            />
                        </td>
                    )}
                 />           
                 
                 <GridColumn field="submittedCurrency" title="Price Proposal Currency"  width="150px"></GridColumn>
                 <GridColumn field="sourceDateTimestamp" title="Pick-up Date"  width = "150px"></GridColumn>
                 <GridColumn field="destDateTimestamp" title="Delivery Date"  width="120px"></GridColumn>
                 <GridColumn field="comments" title="Comments"  width="300px"></GridColumn>
                        
                 
               
            </Grid>
        );

        return(
            <div>
                  <MDBContainer fluid>
                <MDBRow>
                     <div className="" id="kendoGrid">
                        {grid}
                    </div>
                </MDBRow>
                </MDBContainer>
            </div>
        );
    }
}

export default RFQQuotationGrid;